import React, { useState, useEffect, useContext } from 'react'
import styles from './ManageJobRoutes.module.css'
import { BASE_URL_API } from "../../References/urls";
import AuthContext from '../../store/auth-context';
import { MdCheckBoxOutlineBlank, MdCheckBox, MdOutlineDisabledByDefault } from "react-icons/md";
import { humanReadableTimePassed } from '../../Helper/helpers';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

const ManageJobRoutes = () => {
    // User should be able to list all the jobs with the status..
    // should be able to select job identifiers for which they want to generate
    // should be able to call the api /seoGenerateJobRoute ... payload is job identifiers json array.. 

    // let first fetch all the jobs with status pending route generation
    // then show a list with checkboxes to select the jobs
    // then a button to generate routes for selected jobs
    const authCtx = useContext(AuthContext);
    const [selectedJobs, setSelectedJobs] = useState([]) // selected job identifiers

    const [isLoading, setIsLoading] = useState(false);
    const [jobsFetchingStatus, setJobsFetchingStatus] = useState('FETCHING'); //FETCHED
    const [jobsData, setJobsData] = useState([
        {
            "ID": "6484",
            "job_id": "JOB1765193414",
            "title": "Gents Hairdresser \/ Hairstylist",
            "store_id": "841765193197004555",
            "job_category_id": "17",
            "job_category_name": "Gents Hairdresser \/ Hairstylist",
            "creation_date": "2025-12-08 17:00:14",
            "is_active": "1",
            "jobRoute": "gents-hair-dresser-job-in-loreal-professional-lbs-hair-and-beauty-unisex-salon-chakia-bihar",
            "isClosed": "0",
            "company_name": "L'OREAL PROFESSIONAL LBS HAIR AND BEAUTY UNISEX SALON ",
            "address": "Lic office, Vyapar Mandal fast floor, Hospital Rd, Chakia, Bihar 845412",
            "dgAreaIdentifier": ""
        },
    ]);
    const [categoryOptionsData, setCategoryOptionsData] = useState([]);
    const [selectedJobCategories, setSelectedJobCategories] = useState([])
    const [selectedLocations, setSelectedLocations] = useState([])

    const [isRoute, setIsRoute] = useState(null);
    const [isActive, setIsActive] = useState(null);
    const [orderBy, setOrderBy] = useState('NEWEST_FIRST');


    const getAllJobs = async () => {
        setJobsFetchingStatus('FETCHING');
        const allJobsResponse = await fetch(BASE_URL_API + "/getAllJobs",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    isRoute: isRoute,
                    isActive: isActive,
                    orderBy: orderBy,
                    jobCategories: selectedJobCategories,
                    locations: selectedLocations
                })
            });

        if (!allJobsResponse.ok) {
            console.log("Something went wrong while fetching the jobs");
        } else {
            const allJobsRespo = await allJobsResponse.json();
            if (allJobsRespo.status === 'success') {
                setJobsData(allJobsRespo.response);
            } else {
                if (allJobsRespo.message === 'token Expired, please login again!') {
                    authCtx.logout();
                } else {
                    setJobsData([]);
                }
            }
        }
        setJobsFetchingStatus('FETCHED');
    }

    useEffect(() => {
        getAllJobs();
    }, [isRoute, isActive, orderBy, selectedJobCategories, selectedLocations]);

    const handleJobSelection = (jobId) => {
        // Handle job selection logic
        if (selectedJobs.includes(jobId)) {
            setSelectedJobs(selectedJobs.filter(job_id => job_id !== jobId))
        } else {
            setSelectedJobs([...selectedJobs, jobId])
        }

    }

    const handleGenerateRoutes = async () => {
        // Call API to generate job routes
        console.log("Generating routes for jobs: ", selectedJobs);
        const response = await fetch(BASE_URL_API + "/seoGenerateJobRoute", {
            method: "POST",
            body: JSON.stringify({
                token: authCtx.token,
                jobIdentifiers: JSON.stringify(selectedJobs)
            })
        });

        if (!response.ok) {
            console.log("Something went wrong while generating job routes");
        } else {
            const resp = await response.json();
            if (resp.status === 'success') {
                toast("Job routes generated successfully!");
                console.log("Generate Job Routes Response: ", resp);
                // Refresh the job list
                getAllJobs();
                setSelectedJobs([]);
            } else {
                if (resp.message === 'token Expired, please login again!') {
                    authCtx.logout();
                } else {
                    alert("Failed to generate job routes: " + resp.message);
                }
            }
        }   
    }



    return (
        <div className={styles.mainWrapper}>
            <div className={styles.headerContainer}>
                <div className={styles.filtersContainer}>
                    <div className={styles.filterItems}>
                        <div>
                            {jobsData.length} Jobs Found
                        </div>
                        <div>
                            <label>Job Route Status:</label>
                            <select value={isRoute || ''} onChange={(e) => setIsRoute(e.target.value || null)}>
                                <option value=''>All</option>
                                <option value='UPDATED'>Updated</option>
                                <option value='NOT_UPDATED'>Not Updated</option>
                            </select>
                        </div>

                        <div>
                            <label>Job Active Status:</label>
                            <select value={isActive || ''} onChange={(e) => setIsActive(e.target.value || null)}>
                                <option value=''>All</option>
                                <option value='ACTIVE'>Active</option>
                                <option value='NOT_ACTIVE'>Not Active</option>
                            </select>
                        </div>

                        <div>
                            <label>Order By:</label>
                            <select value={orderBy} onChange={(e) => setOrderBy(e.target.value)}>
                                <option value='NEWEST_FIRST'>Newest First</option>
                                <option value='NEWEST_LAST'>Oldest First</option>
                            </select>
                        </div>
                    </div>

                    <div>
                        <button onClick={() => {
                            setIsRoute(null);
                            setIsActive(null);
                            setOrderBy('NEWEST_FIRST');
                            setSelectedJobCategories([]);
                            setSelectedLocations([]);
                            getAllJobs();
                        }}>Reset Filters</button>
                    </div>

                </div>

                <div>
                    <button onClick={handleGenerateRoutes} disabled={selectedJobs.length === 0}>
                        Generate Routes for Selected Jobs ({selectedJobs.length})
                    </button>
                </div>
            </div>

            <div className={styles.bodyContainer}>
                {jobsFetchingStatus === 'FETCHING' ? (
                    <p>Loading jobs...</p>
                ) : (
                    <div>
                        <table className={styles.jobsTable}>
                            <thead>
                                <tr>
                                    <th className={styles.selectableCheckbox}>
                                        {selectedJobs.length === jobsData.filter(job => !job.jobRoute).length ? (
                                            <MdCheckBox size={22} onClick={() => setSelectedJobs([])} title="Deselect All Jobs Without Route" />
                                        ) : (
                                            <MdCheckBoxOutlineBlank size={22} onClick={() => setSelectedJobs(jobsData.filter(job => !job.jobRoute).map(job => job.job_id))} title="Select All Jobs Without Route" />
                                        )}  
                                    </th>
                                    <th>Job ID</th>
                                    <th>Title</th>
                                    <th>Company Name & Location</th>
                                    <th>Job Route</th>
                                    <th>Posted On</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobsData.map((job) => (
                                    <tr key={job.ID}>
                                        
                                        {job.jobRoute ? (
                                            <td className={styles.disabledCheckbox}> 
                                                <MdOutlineDisabledByDefault size={22} title="Job route already generated" />
                                            </td>
                                        ) : (
                                            <td onClick={() => handleJobSelection(job.job_id)}
                                                className={styles.selectableCheckbox}
                                            >
                                                {selectedJobs.includes(job.job_id) ? (
                                                    <MdCheckBox size={22} />
                                                ) : (
                                                    <MdCheckBoxOutlineBlank size={22} />
                                                )}
                                            </td>
                                        )}

                                        <td>{job.job_id}</td>
                                        <td>{job.title}</td>
                                        <td>
                                            <Link to= {`/manage-stores/${job?.store_id}`} target="_blank" className={styles.companyNameText}>  
                                            {job.company_name}
                                            <br />
                                            <span className={styles.addressText}> 
                                            {job.address}
                                            </span>
                                            </Link>
                                        </td>
                                        <td>
                                            <a href={`https://stylelink.in/job/${job.jobRoute}`} target="_blank" className={styles.jobRouteText}>{job.jobRoute || 'Not Generated'}</a>
                                        </td> 
                                        <td>
                                            <span className={styles.postedOnText}>
                                                {humanReadableTimePassed(job.creation_date)}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>


                    </div>
                )}
            </div>
        </div>
    )
}

export default ManageJobRoutes